"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=taker-finalized-proposal.js.map